module.exports = __webpack_public_path__ + "img/1472111769.3eef22b6.jpg";